import { motion } from "framer-motion";
import { Zap, Clock3, ClipboardCheck } from "lucide-react";

const benefits = [
  { icon: Zap, title: "Fast Response", desc: "Engage new buyer and seller inquiries while interest is high." },
  { icon: Clock3, title: "24/7 Follow-Up", desc: "Keep conversations moving nights and weekends — when many prospects actually reach out." },
  { icon: ClipboardCheck, title: "Consistent Lead Handling", desc: "Every inquiry enters a defined follow-up process, even when you're at a showing." },
];

export default function Benefits() {
  return (
    <section data-testid="benefits-section" className="bg-[#0D1220] border-y border-white/5">
      <div className="max-w-6xl mx-auto px-6 py-14 md:py-20 grid sm:grid-cols-3 gap-10">
        {benefits.map((b, i) => (
          <motion.div
            key={b.title}
            data-testid={`benefit-${i}`}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ delay: i * 0.1, duration: 0.5 }}
            className="flex sm:flex-col items-start gap-4"
          >
            <div className="h-11 w-11 shrink-0 rounded-xl bg-cyan-500/10 text-cyan-300 flex items-center justify-center">
              <b.icon size={22} strokeWidth={1.75} />
            </div>
            <div>
              <h3 className="font-heading font-bold text-lg text-white">{b.title}</h3>
              <p className="mt-1.5 text-slate-300 text-base leading-relaxed">{b.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
